import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionInterceptor } from 'go-modules/session-manager/session-manager.interceptor';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { SessionManagerService, sessionManagerToken } from 'go-modules/session-manager/session-manager.service';
import { EventService } from '../../event/event.service';
import { RouterService } from '@go-modules/services/router/router.service';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor (
		@Inject(sessionManagerToken) private sessionManager: SessionManagerService,
		private routerService: RouterService,
		private eventService: EventService,
		private environmentVarsService: EnvironmentVarsService
	) {}

	public intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Configure header if goreact request
		const isGoReactApiRequest = req.url.indexOf(clientSettings.GoReactV2API) === 0;
		if (isGoReactApiRequest) {
			req = req.clone({
				withCredentials: true
			});
		}

		return next.handle(req).pipe(
			catchError((e) => {
				if (isGoReactApiRequest && e.status === 401 &&
					this.environmentVarsService.environmentIs(ENVIRONMENTS.LTI)) {
					this.eventService.broadcast(EVENT_NAMES.AUTH_ENDED);
				}

				return throwError(() => SessionInterceptor.responseError(
					e,
					this.sessionManager,
					this.eventService,
					this.routerService
				));
			})
		);
	}
}
